import React from "react";
import styled from "@emotion/styled";
export const QuizHeader = ({ children }) => {
  return <Header>{children}</Header>;
};

const Header = styled.p`
  font-family: "Noto Sans Thai";
  font-weight: 600;
  font-size: 24px;
  color: #058459;
  margin-bottom: 16px;
`;
